module.exports = __webpack_public_path__ + "static/media/hz11.551e9416.png";